<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                :class="mode ? 'content__titleday' : 'content__titlenight'"
                class="content-title d-flex align-center mr-2"
              >
                {{ $t("message.bonus_penalty_reasons") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12" class="flex-style text-right">
            <crm-create-and-column-settings
              :permission="$options.name"
              :class="mode ? 'button__settingsday' : 'button__settingsnight'"
              @c-create="drawerCreate = true"
              :columns="columns"
              @c-change="updateColumn"
              :v_can_create="'penalty_reasons.create'"
            >
            </crm-create-and-column-settings>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->

      <div class="card-table-header table-crm-smart">
        <table
          :class="mode ? 'table__myday' : 'table__mynight'"
          class="table-my-code table-bordered"
          v-loading="loadingData"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.name.show">
                {{ columns.name.title }}
              </th>
              <th v-if="columns.value.show">
                {{ columns.value.title }}
              </th>
              <th v-if="columns.type.show">
                {{ columns.type.title }}
              </th>
              <th v-if="columns.branch.show">
                {{ columns.branch.title }}
              </th>
              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>

              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.id"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.name.show">
                <crm-input
                  :placeholder="columns.name.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.name"
                ></crm-input>
              </th>
              <th v-if="columns.value.show">
                <crm-input
                  :placeholder="columns.value.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.value"
                ></crm-input>
              </th>
              <th v-if="columns.type.show">
                <el-select
                  clearable
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="$t('message.type')"
                  size="mini"
                  class="d-block"
                  v-model="filterForm.reason_type"
                >
                  <el-option
                    :label="$t('message.bonuses')"
                    :value="'bonuses'"
                  ></el-option>
                  <el-option
                    :label="$t('message.sanction')"
                    :value="'sanction'"
                  ></el-option>
                </el-select>
              </th>
              <th v-if="columns.branch.show">
                <select-branch
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :id="filterForm.branch_id"
                  v-model="filterForm.branch_id"
                ></select-branch>
              </th>
              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                ></crm-date-picker>
              </th>

              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                ></crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr v-for="reason in list" :key="reason.id" class="cursor-pointer">
              <td v-if="columns.id.show">{{ reason.id }}</td>
              <td v-if="columns.name.show">
                {{ reason.name }}
              </td>
              <td v-if="columns.type.show">
                {{ reason.value }}
                {{ reason.penalty_type == "number" ? "" : "%" }}
              </td>
              <td v-if="columns.type.show">
                {{
                  reason.reason_type ? $t("message." + reason.reason_type) : ""
                }}
                <!-- {{reason.reason_type?reason.branch.name:"" }} -->
              </td>
              <td v-if="columns.type.show">
                {{ reason.branch ? reason.branch.name : "" }}
              </td>
              <td v-if="columns.created_at.show">
                {{ reason.created_at }}
              </td>

              <td v-if="columns.updated_at.show">
                {{ reason.updated_at }}
              </td>

              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="reason"
                  :actions="actions"
                  :permissionShow="'penalty_reasons.update'"
                  :permissionDestroy="'penalty_reasons.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>

      <div class="app-modal app-modal__full">
        <el-drawer
          :with-header="false"
          :visible.sync="drawerCreate"
          size="70%"
          ref="drawerCreate"
          @opened="drawerOpened('drawerCreateChild')"
          @closed="drawerClosed('drawerCreateChild')"
        >
          <crm-create
            ref="drawerCreateChild"
            drawer="drawerCreate"
          ></crm-create>
        </el-drawer>

        <el-drawer
          :with-header="false"
          :visible.sync="drawerUpdate"
          size="70%"
          ref="drawerUpdate"
          @opened="drawerOpened('drawerUpdateChild')"
          @closed="drawerClosed('drawerUpdateChild')"
        >
          <crm-update
            :selectedItem="selectedItem"
            ref="drawerUpdateChild"
            drawer="drawerUpdate"
          ></crm-update>
        </el-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import list from "@/utils/mixins/list";
// import selectOrHiddenCompany from "@/components/filters/inventory/select-or-hidden-company";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "ReasonController",
  mixins: [list],
  components: {
    CrmCreate,
    CrmUpdate
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      list: "penaltyReasons/list",
      columns: "penaltyReasons/columns",
      pagination: "penaltyReasons/pagination",
      statues: "penaltyReasons/statues",
      filter: "penaltyReasons/filter",
      sort: "penaltyReasons/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["edit", "delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "penaltyReasons/index",
      setPagination: "penaltyReasons/setPagination",
      updateSort: "penaltyReasons/updateSort",
      updateFilter: "penaltyReasons/updateFilter",
      updateColumn: "penaltyReasons/updateColumn",
      updatePagination: "penaltyReasons/updatePagination",
      show: "penaltyReasons/show",
      empty: "penaltyReasons/empty",
      delete: "penaltyReasons/destroy",
      refreshData: "penaltyReasons/refreshData"
    })
  }
};
</script>
